export default __webpack_public_path__ + "static/media/maestro-single.7239befc.svg";